<template>
  <base-section id="theme-features">
    <base-section-heading title="Ganalla 20/40 Mesh">
El granate CyD Group es un mineral natural totalmente ecológico, este Garnet es tipo almandino, uno de los minerales más duros, el cual es un granate de roca dura cristalina.
Nuestro Garnet CyD Group son granos angulares afilados que se pueden utilizar para un muy amplio campo de aplicaciones en arenado, microarenado, aeroabrasión en seco y en húmedo.
  </base-section-heading>
  <v-container>
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>
        </v-col>
      </v-row>

      <iframe width="560" height="315" src="https://www.youtube.com/embed/hauBSFmVBtE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [{
          color: 'blue',
          title: 'Duro y no polvoroso',
          icon: 'mdi-cards-diamond',
          text: 'Nuestro Garnet CyD Group se caracteriza por una alta dureza (7,5 – 8 Mohs) y resistencia, una muy baja fragilidad y un elevado peso específico (4.1). Dichas características, junto con la morfología angular, permiten realizar el arenado en seco sin dispersión de polvo, logrando una cantidad de arenado superior con una rugosidad superficial uniforme y bien controlada, regulable en base a la granulometría utilizada y a la presión de trabajo. El estándar de arenado SA3 se obtiene sin ninguna dificultad.El elevado peso específico permite al producto Garnet CyD Group transferir una gran cantidad de energía cinética en el momento del impacto sobre la superficie, lo cual se traduce en un notable aumento de la eficacia y de las prestaciones de arenado y limpieza.Gracias a la gran resistencia y a la muy baja fragilidad, Garnet CyD Group se puede reutilizar varias veces, reduciendo los costos de arenado y limpieza ligados a los elementos consumibles.',
        },
        {
          color: 'blue',
          title: 'Dureza y angulosidad',
          icon: 'mdi-diamond-stone',
          text: 'Las partículas angulares y una consistente uniformidad dan más control al operario de la boquilla para lograr el resultado final que busque en su trabajo.El Garnet CyD Group no sufre fraccionamiento en su procesado.Su alto grado de dureza, permite su reutilización hasta 7 veces sin grandes mermas de cualidades.No hay riesgo de silicosis. No es nocivo para la salud.',
        },
        {
          color: 'blue',
          title: 'Seguro',
          icon: 'mdi-saw-blade',
          text: 'Por ser atóxico, el Garnet CyD Group está muy por debajo de los valores máximos determinados por las normativas ambientales en relación a los componentes silicógenos (silicio cristalino), tóxicos y cancerígenos, garantizando un ambiente de trabajo seguro y limpio con una notable reducción del ruido, gracias a la posibilidad de arenar a baja presión.',
        },
        {
          color: 'blue',
          title: 'Económico',
          icon: 'mdi-cash-usd',
          text: 'La minúscula composición de su cristal, un elevado peso específico y las más bajas presiones de disparo, permiten un menor consumo de abrasivo que se reduce hasta el 50-75% respecto a los abrasivos tradicionales utilizados en arenado.',
        },
        {
          color: 'blue',
          title: 'Tamaño',
          icon: 'mdi-vector-rectangle',
          text: 'Mesh 20/40 escala granulométrica: 0,5 – 1 mm',
        },
        {
          color: 'blue',
          title: 'Características físico-químicas',
          icon: 'mdi-flask-outline',
          text: 'Aspecto: Mineral Forma: Angular Peso específico: 4.1 Color: de rosa a rojo oscuro Dureza: 7.5 – 8 Mohs',
        },
      ],
    }),
  }
</script>
